import 'bootstrap/js/src/util.js';
import 'bootstrap/js/src/collapse.js';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/tab.js';
// import 'bootstrap/js/src/modal.js';



// WEBPACK FOOTER //
// ./scripts/autoload/_bootstrap.js